import { openBlock as o, createElementBlock as t, createElementVNode as r } from "vue";
import n from "../_virtual/_plugin-vue_export-helper.mjs";
const s = {}, l = {
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function c(i, e) {
  return o(), t("svg", l, e[0] || (e[0] = [
    r("path", {
      d: "M8.53553 1.53553L1.46447 8.6066M1.46447 1.53553L8.53553 8.6066",
      stroke: "currentColor",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const m = /* @__PURE__ */ n(s, [["render", c]]);
export {
  m as default
};
